import React, { useState } from "react";
import TextInput from "@Components/TextInput/TextInput";
import CustomButton from "@Components/Button/Button";
import { eventBus } from "@Utils/EventBus";
import { CLOSE_MODAL } from "@Constants/modal";
import CloseIcon from "@Assets/icons/dashboard/close.svg";
import SearchIcon from "@Assets/icons/search.svg";
import { Form } from "antd";
import FormItem from "@Components/FormItem/FormItem";
import ArrowRight from "@Assets/icons/arrow-right.svg";
import Lock from "@Assets/icons/lock.svg";
import { useChangePassword } from "@Pages/AuthScreens/ResetPassword/ResetPasswordQuery";
import { changePasswordPayloadType } from "@Utils/types";

const ChangePasswordModal: React.FC<{onClose: () => void}> = ({onClose}) => {
  const [form] = Form.useForm();

  const handleClose = () => {
    form.resetFields();
    eventBus.emit(CLOSE_MODAL, null);
    onClose();
  };

  const onChangePassSuccess = (payload: changePasswordPayloadType) => {
    handleClose();
  };

  const { mutate: changePassword, isPending: isChangingPassword } =
    useChangePassword(onChangePassSuccess);

  const handleUpdatePassword = async (data: any) => {
    const payload: changePasswordPayloadType = {
      oldPassword: data?.currentPassword ?? null,
      newPassword: data?.password ?? null,
      logOutOfAllAccounts: true,
    };
    changePassword(payload);

  };

  return (
    <div className="w-full max-w-[680px] bg-white rounded-lg">
      {/* Header */}
      <div className="flex justify-between items-center px-2 pt-2 pb-4 border-b border-gray-200">
        <h4 className="text-xl !font-bold text-gray-900  tracking-wide">
          Change Password
        </h4>
        <button
          onClick={handleClose}
          className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close modal"
        >
          <CloseIcon className="w-5 h-5" />
        </button>
      </div>

      <div className="px-2 !mb-4 pt-2 ">
        <Form form={form} onFinish={handleUpdatePassword} className="py-2">
          <FormItem
            name="currentPassword"
            label="Current Password"
            rules={[
              {
                required: true,
                message: "Please Enter your current password!",
              },
            ]}
            inputConfig={{
              label: "Current Password",
              isPassword: true,
              placeholder: "Enter your current password",
              leftIcon: <Lock />,
            }}
          />
          <FormItem
            name="password"
            label="New Password"
            rules={[
              { required: true, message: "Please Enter your new password!" },
              { min: 8, message: "Password must be at least 8 characters" },
            ]}
            inputConfig={{
              label: "New Password",
              isPassword: true,
              placeholder: "Enter your password",
              leftIcon: <Lock />,
            }}
          />
          <FormItem
            name="confirmPassword"
            label="Confirm New Password"
            rules={[
              {
                required: true,
                message: "Please Enter your confirm password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
            inputConfig={{
              label: "Confirm New Password",
              isPassword: true,
              placeholder: "Enter your password",
              leftIcon: <Lock />,
            }}
          />
          <Form.Item className="text-center max-w-full !pt-2">
            <CustomButton
              title={"Update"}
              shape="round"
              btnColor="danger"
              type="primary"
              iconPosition="right"
              icon={<ArrowRight />}
              className="w-full h-[44px] sm:h-[50px] font-bold tracking-[1%] !rounded-[12px] text-sm sm:text-base"
              htmlType="submit"
              isLoading={isChangingPassword}
              disabled={isChangingPassword}
            />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
